import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-300 rounded-full bg-palomitas-gold hover:bg-palomitas-goldHover shadow-lg hover:shadow-xl transform hover:-translate-y-1';
  if (href) {
    return <motion.a href={href} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-28">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-29">
      {children}
    </motion.button>;
}